import { render } from "./footerMenu.vue?vue&type=template&id=bb0a84a4&scoped=true"
import script from "./footerMenu.vue?vue&type=script&lang=js"
export * from "./footerMenu.vue?vue&type=script&lang=js"

import "./footerMenu.vue?vue&type=style&index=0&id=bb0a84a4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0a84a4"]])

export default __exports__